const appEmailDomain = import.meta.env.VITE_APP_EMAIL_DOMAIN || "pannovation.com";

export const brand = {
  appName: import.meta.env.VITE_APP_NAME || "Pannovation",
  appWatchName: import.meta.env.VITE_APP_WATCH_NAME || "Pannovation Watch",
  iosAppUrl:
    import.meta.env.VITE_IOS_APP_URL || "https://apps.apple.com/us/app/panpan/id1611176744",
  androidAppUrl:
    import.meta.env.VITE_ANDROID_APP_URL ||
    "https://play.google.com/store/apps/details?id=watch.panpan",
  appEmailDomain,
  supportEmail: `support@${appEmailDomain}`,
  appDomain: import.meta.env.VITE_APP_DOMAIN || "pannovation.com",
} as const;
